function wholesaleApplication() {
  const applicationFormWrapper = document.querySelector('[data-wholesale-application-form-wrapper]');
  const showApplicationFormTriggers = document.querySelectorAll('[data-wholesale-application-trigger]');
  const hideApplicationFormTriggers = document.querySelectorAll('[data-wholesale-application-close]');
  const stickyCTA = document.querySelector('.sticky-cta');
  const siteHTML = document.querySelector('[data-site-html]');

  showApplicationFormTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      applicationFormWrapper.classList.add('active');
      siteHTML.style.overflow = 'hidden';
      document.body.classList.add('drawer-active');
      stickyCTA.classList.add('hide');
      trapFocus(applicationFormWrapper);
    });
  });

  hideApplicationFormTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      closeModal();
    });
  });

  applicationFormWrapper.addEventListener('keydown', (event) => {
    if (event.keyCode === 27) {
      closeModal();
    }
  });

  applicationFormWrapper.addEventListener('click', (event) => {
    if (event.target.getAttribute('data-wholesale-application-form-wrapper') !== null) {
      closeModal();
    }
  });

  function closeModal() {
    applicationFormWrapper.classList.remove('active');
    siteHTML.style.overflow = 'initial';
    document.body.classList.remove('drawer-active');
    stickyCTA.classList.remove('hide');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  wholesaleApplication();
});

// needs swiper

function wholesaleInspiration() {
  const wholesaleInspirationWrapper = document.querySelector('[data-wholesale-inspiration]');

  if (window.matchMedia('(max-width: 750px)')) {
    new Swiper(wholesaleInspirationWrapper, {
      loop: false,
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  wholesaleInspiration();
});
